<template>
  <div class="col12 config-parent">
    <div class="vertical rw-tabs" v-if="!loading && config !== undefined">
      <div class="tabset">
        <div v-for="tab in tabs" @click="showTab(tab.name)" :key="tab.name" :class="{active: currentTab === tab.name, tab: true}">
          {{tab.title}}
        </div>
      </div>
      <div class="tabs-container">
        <div v-show="currentTab === 'product'" :class="{'tab-content': true, 'custom-tab': config.group === 'custom'}">
          <div class="row">
            <div class="col-left">
              Produkt
            </div>
            <div class="col-right">
              <config-option class="row" :options="options.groups" v-model="config.group" @change="change('group')" />
            </div>
          </div>
          <div class="row" v-if="config.group !== 'custom'">
            <div class="col-left">
              Art
            </div>
            <div class="col-right">
              <config-option class="row" :options="options.subgroups[config.group]" v-model="config.subgroup" @change="change('subgroup')" />
            </div>
          </div>
          <div class="row" v-if="config.group !== 'custom'">
            <div class="col-left">
              Spezifikation
            </div>
            <div class="col-right">
              <config-option class="row" :options="options.models[config.group][config.subgroup]" v-model="config.model" @change="change('model')" />
            </div>
          </div>
          <template v-if="productAdditionalStructure && evaluateCondition(productAdditionalStructure.condition)">
            <template v-for="(opt, key) in productAdditionalStructure.items" v-if="evaluateCondition(opt.condition) && opts[opt.name] !== undefined">
              <div class="row" :key="opt.name+key+config.group">
                <div class="col-left">
                  {{opts[opt.name].title}}
                </div>
                <div class="col-right">
                  <config-option class="row" :options="values(opts[opt.name])" v-model="config[opt.name]" @change="change(opt.name)" :key="'a' + opt.name+key+config.group" />
                </div>
              </div>
            </template>
          </template>
          <auto-resize-textarea v-if="config.group === 'custom'" placeholder="Bitte beschreiben Sie hier Ihre Wünsche und Anforderungen." v-model="config.custom"></auto-resize-textarea>
        </div>
        <div v-for="tab in structure" v-show="currentTab === tab.id" :key="tab.id" class="tab-content" style="display: block">
          <template v-if="tab.add_to_product_tab !== true">
            <template v-for="(opt, key) in tab.items" v-if="evaluateCondition(opt.condition) && opts[opt.name] !== undefined">
              <div class="row" :key="opt.name+key+config.group">
                <div class="col-left">
                  {{opts[opt.name].title}}
                </div>
                <div class="col-right">
                  <config-option class="row" :options="values(opts[opt.name])" v-model="config[opt.name]" @change="change(opt.name)" :key="'a' + opt.name+key+config.group" />
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigOption from '@/components/ConfigOption'
import Options from '@/Options'
import AutoResizeTextarea from '@/components/AutoResizeTextarea'

// Helper

function satisfyConstraint (options, startValues, constraint) {
  let length = options.length
  let values = solveConstraint(options, startValues, constraint, length, 0)
  if (constraint(values) === true) {
    return values
  } else {
    return null
  }
}

function solveConstraint (options, values, constraint, length, pos) {
  if (pos < options.length - 1) {
    values = solveConstraint(options, values, constraint, length, pos + 1)
  }
  if (constraint(values) === true) {
    return values
  }

  for (let val of options[pos]) {
    values[pos] = val
    if (pos < options.length - 1) {
      values = solveConstraint(options, values, constraint, length, pos + 1)
    }
    if (constraint(values) === true) {
      return values
    }
  }
  return values
}

// Component

export default {
  name: 'Config',
  components: {
    ConfigOption,
    AutoResizeTextarea
  },
  model: {
    prop: 'config',
    event: 'changed'
  },
  props: ['config'],
  data () {
    return {
      loading: true,
      options: {},
      open: true,
      currentTab: 'product'
    }
  },
  methods: {
    log (stuff) {
      console.info(stuff)
    },
    change (property) {
      if (this._disableChangeEvent === true) {
        return true
      }
      this._disableChangeEvent = true
      if (property) {
        this.enforceConstraints(property)
      }
      this._disableChangeEvent = false
      this.$emit('change', this.config)
      if ((property === 'group' && this.config.group !== 'custom') || property === 'subgroup' || property === 'model') {
        this.$nextTick(() => this.fixConfig(property, false))
      }
    },
    enforceConstraints (property) {
      for (let constraint of this.constraints) {
        if (constraint.params.includes(property)) {
          this.enforceConstraint(constraint, property)
        } else if (constraint.fixed_params.includes(property)) {
          this.enforceConstraint(constraint)
        }
      }
    },
    enforceConstraint (constraint, fixProp) {
      let fixedVals = constraint.fixed_params.map(name => this.config[name])
      let fixedProp = fixProp !== undefined ? fixProp : constraint.params[0]
      let fixedPropIndex = constraint.params.indexOf(fixedProp)
      let fixedPropVal = this.config[fixedProp]
      let propsWithoutFixed = constraint.params.slice()
      propsWithoutFixed.splice(fixedPropIndex, 1)
      let valsWithoutFixed = propsWithoutFixed.map(name => this.config[name])
      let optsWithoutFixed = propsWithoutFixed.map(name => Object.keys(this.opts[name].values))
      valsWithoutFixed = satisfyConstraint(optsWithoutFixed, valsWithoutFixed, vals => {
        let valsWithFixed = vals.slice()
        valsWithFixed.splice(fixedPropIndex, 0, fixedPropVal)
        return constraint.func(...fixedVals, ...valsWithFixed)
      })
      if (valsWithoutFixed !== null) {
        for (let i = 0; i < propsWithoutFixed.length; i++) {
          let name = propsWithoutFixed[i]
          this.config[name] = valsWithoutFixed[i].toString()
        }
      } else {
        console.error({msg: 'found no combination to satisfy constraint', property: fixedProp, constraint: constraint, fixedVals: fixedVals, propsWithoutFixed: propsWithoutFixed, optsWithoutFixed: optsWithoutFixed, valsWithoutFixed: valsWithoutFixed})
      }
    },
    showTab (name) {
      this.currentTab = name
    },
    defaultTab () {
      for (let tab of this.tabs) {
        if (tab.name === this.currentTab) {
          return
        }
      }
      this.currentTab = this.tabs[0].name
    },
    fixConfig (force = false) {
      let c = this.config
      if (c === undefined) {
        return
      }
      if (!c.group || c.group === '') {
        this.$set(c, 'group', Object.keys(this.options.groups)[0])
      }
      if (!c.custom) {
        this.$set(c, 'custom', '')
      }
      if (c.group === 'custom') {
        return
      }
      if (force === 'group' || !c.subgroup || c.subgroup === '') {
        this.$set(c, 'subgroup', Object.keys(this.options.subgroups[c.group])[0])
      }
      if (force === 'group' || force === 'subgroup' || !c.model || c.model === '') {
        this.$set(c, 'model', this.options.models[c.group][c.subgroup][0])
      }
      for (let prop in this.options.options[c.group][c.model].fixed) {
        this.$set(c, prop, this.options.options[c.group][c.model].fixed[prop])
      }
      let opts = this.options.options[c.group][c.model].options
      for (let opt in opts) {
        if (force || !c[opt] || c[opt] === '') {
          this.$set(c, opt, Object.keys(opts[opt].values)[0])
        }
      }
      for (let prop in this.fixed) {
        this.$set(c, prop, this.fixed[prop])
      }
      for (let constraint of this.constraints) {
        this.enforceConstraint(constraint)
      }
      this.$emit('change')
    },
    values (opt) {
      if ('filter' in opt) {
        let args = opt.filter.params.map(name => this.config[name])
        return Object.keys(opt.values)
          .filter(v => opt.filter.func(v, ...args))
          .reduce((obj, key) => {
            return {
              ...obj,
              [key]: opt.values[key]
            }
          }, {})
      } else {
        return opt.values
      }
    },
    evaluateCondition (cond) {
      if (!cond) {
        return true
      }
      return cond.func(...cond.params.map(name => this.config[name]))
    }
  },
  computed: {
    productAdditionalStructure () {
      if (this.structure && this.structure[0] && this.structure[0].add_to_product_tab === true) {
        return this.structure[0]
      } else {
        return null
      }
    },
    opts () {
      return this.productOptions.options || []
    },
    fixed () {
      return this.productOptions.fixed || {}
    },
    structure () {
      return (this.options.structures && this.options.structures[this.config.group] && this.options.structures[this.config.group][this.config.model]) || {}
    },
    constraints () {
      return this.productOptions.constraints || []
    },
    productOptions () {
      return (this.options.options && this.options.options[this.config.group] && this.options.options[this.config.group][this.config.model] && this.options.options[this.config.group][this.config.model]) || {}
    },
    productTabs () {
      if (this.config === undefined) {
        return []
      }
      if (this.config.group === 'custom') {
        return []
      } else {
        return Object.values(this.structure)
          .filter(s => {
            if (s.add_to_product_tab === true) {
              return false
            }
            if ('condition' in s) {
              return s.condition.func(...s.condition.params.map(name => this.config[name]))
            } else {
              return true
            }
          })
          .map(s => { return {name: s.id, title: s.title} }) || []
      }
    },
    tabs () {
      return [{name: 'product', title: 'Schnitt'}].concat(this.productTabs)
    },
    modelName () {
      if (this.productOptions.modelName && this.productOptions.modelName.enabled === true) {
        let vals = this.productOptions.modelName.properties.map(prop => this.config[prop])
        return this.productOptions.modelName.prefix + '__' + vals.join('_')
      } else {
        return 'none'
      }
    }
  },
  created () {
    window.box = this
    Options.getOptions().then(options => {
      this.options = options
      this.loading = false
      this.fixConfig()
    })
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        if (!this.loading) {
          if (newVal !== oldVal) {
            this.fixConfig()
          } else if (newVal.group !== oldVal.group) {
            this.fixConfig('group')
          } else if (newVal.subgroup !== oldVal.subgroup) {
            this.fixConfig('subgroup')
          } else if (newVal.model !== oldVal.model) {
            this.fixConfig('model')
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

.tab-nav {
  overflow: hidden;
}

.tab-body {
  overflow: hidden;
}

.tab-content {
  padding-bottom: 36px;
  padding-top: 12px !important;
  padding-left: 0 !important;
}

.tab-content.custom-tab {
  padding-bottom: 0 !important;
}

textarea {
  background: transparent;
  border: none;
  margin-bottom: 2px;
  min-height: 180px;
}

.column {
  width: 160px;
  float: left;
}

.deleteButton {
  float: right;
}

.row::after {
  content: '';
  display: table;
  clear: both;
}

.row {
  padding-left: 24px;
  padding-right: 24px;
}

.row:hover {
  background-color: rgba(230,230,230, 0.3);
}

.row .row {
  background-color: transparent !important;
  padding-right: 0;
}

.row > .col-left {
  padding: 12px 0;
  @media screen and (min-width: 1024px) {
    float: left;
    width: 20%;
  }
}

.row > .col-right {
  @media screen and (min-width: 1024px) {
    float: left;
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Config.vue